import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@context/AuthContext";

export default function AuthWrapper({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="fc-login-page">
        <div className="text-center">
          <i className="fa-solid fa-spinner fa-spin mb-2 d-block" style={{ fontSize: 24, color: "var(--fc-blue)" }} />
          <p style={{ fontSize: 13, color: "var(--fc-text-muted)" }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
